import React from 'react';
import { connect } from "react-redux";
import { ILogInUserAction, createLogInUserAction, ILogInType } from "../actions/LogInActions";
import { IState } from '../state/State';
import { ErrorType } from '../datatypes/ErrorType';

export interface ISignedOutLoginBodyProps {
    logInUser: (body: string) => ILogInUserAction;
    logInState: ILogInType; 
  }

const handleSubmit = (e: any, props: ISignedOutLoginBodyProps) => {
    // Prevent the page from refreshing on form submit as we'll refresh the UI ourselves from the log in action.
    e.preventDefault();

    let username: string = (document.getElementById("loginUsername") as HTMLInputElement).value;
    let password: string = (document.getElementById("loginUserPassword") as HTMLInputElement).value;
  
    // Need to URL encode the values for sending up (requirement for OAuth).
    username = encodeURIComponent(username);
    password = encodeURIComponent(password);
  
    // Log the user in.
    props.logInUser(`grant_type=password&username=${username}&password=${password}`);
  }
  
const SignedOutLoginBody: React.FC<ISignedOutLoginBodyProps> = (props: ISignedOutLoginBodyProps) => {
    let errorState = null;
    switch (props.logInState.errorType)
    {
        case ErrorType.LocalError:
            errorState = <label className="ErrorLabel">Failed to log in due to the following error: {props.logInState.errorMessage}. This indicates a bug in the website; please let us know at our Discord channel using the icon at the bottom of the page.</label>
            break;
        case ErrorType.ServerError:
            errorState = <label className="ErrorLabel">Failed to log in due to the following error on the server: {props.logInState.errorMessage}</label>
            break;
        case ErrorType.UserError:
            errorState = <label className="ErrorLabel">Failed to log in. {props.logInState.errorMessage}</label>
            break;
        default:
            break;
    }

    return (
      <form className="SignedOutLoginBody" onSubmit={(e) => handleSubmit(e, props)}>
        <label>Username</label>
        <br />
        <input id="loginUsername" />
        <br />
        <br />
        <label>Password</label>
        <br />
        <input id="loginUserPassword" type="password" />
        <br />
        <br />
        <button type="submit">Login</button>
        <br />
        <br />
        {errorState}
      </form>
    );
  }

  const mapStateToProps = (state: IState) => ({logInState: state.logIn.result});

  const actionCreators = {
    logInUser: createLogInUserAction,
  }

  export default connect(mapStateToProps, actionCreators)(SignedOutLoginBody);